import { formatAmount } from "@loot-os/api-contract";
import { Badge } from "@loot-os/ui/components/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@loot-os/ui/components/table";

import { amountColumnHeader, useCurrency } from "../lib/currency";
import { formatDate } from "../lib/format";
import type { UserDetail } from "../lib/trpc";
import { TableMessageRow } from "./TableMessageRow";

const COLUMNS = 5;

/** The latest balance movements from `users.get`, signed, with the balance each one left. */
export function UserLedgerTab({ rows }: { rows: UserDetail["ledger"] }) {
  const currency = useCurrency();
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Type</TableHead>
          <TableHead className="text-right">{amountColumnHeader("Amount", currency)}</TableHead>
          <TableHead className="text-right">
            {amountColumnHeader("Balance after", currency)}
          </TableHead>
          <TableHead>Ref</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && (
          <TableMessageRow colSpan={COLUMNS}>No ledger entries.</TableMessageRow>
        )}
        {rows.map((entry) => (
          <TableRow key={entry.id}>
            <TableCell className="text-muted-foreground">{formatDate(entry.createdAt)}</TableCell>
            <TableCell>
              <Badge variant="outline">{entry.type}</Badge>
            </TableCell>
            <TableCell
              className={`text-right font-mono text-xs ${
                entry.amountCents > 0 ? "text-emerald-400" : "text-red-400"
              }`}
            >
              {entry.amountCents > 0 ? "+" : ""}
              {formatAmount(entry.amountCents, currency)}
            </TableCell>
            <TableCell className="text-right font-mono text-xs">
              {formatAmount(entry.balanceAfterCents, currency)}
            </TableCell>
            <TableCell className="text-muted-foreground">{entry.ref ?? "—"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
